export function StapelLogo({
  size = 32,
  className = '',
}: {
  size?: number;
  className?: string;
  color?: string;
}) {
  return (
    <picture>
      <source type="image/webp" srcSet="/stapel-logo-transparent.webp" />
      <img
        src="/stapel-logo-transparent.png"
        alt="stapel.ai"
        width={size}
        height={size}
        decoding="async"
        className={className}
      />
    </picture>
  );
}
